
import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { Client } from '@/types/client';

interface AddressSectionProps {
  form: UseFormReturn<Client>;
}

export const AddressSection: React.FC<AddressSectionProps> = ({ form }) => {
  return (
    <div className="bg-white p-6 border border-gray-200 rounded-lg">
      <h3 className="text-lg font-montserrat font-semibold text-primary-700 mb-4 flex items-center">
        <div className="w-2 h-2 bg-primary-500 rounded-full mr-2" />
        Endereço
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="md:col-span-2">
          <FormField
            control={form.control}
            name="address_street"
            render={({ field }) => (
              <FormItem>
                <FormLabel className="text-gray-700 font-medium">Logradouro</FormLabel>
                <FormControl>
                  <Input 
                    {...field} 
                    className="bg-white border-gray-200 focus:border-primary-400 focus:ring-primary-400/20 text-gray-900"
                    placeholder="Rua, Avenida, etc."
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </div>

        <FormField
          control={form.control}
          name="address_number"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="text-gray-700 font-medium">Número</FormLabel>
              <FormControl>
                <Input 
                  {...field} 
                  className="bg-white border-gray-200 focus:border-primary-400 focus:ring-primary-400/20 text-gray-900"
                  placeholder="123"
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="address_neighborhood"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="text-gray-700 font-medium">Bairro</FormLabel>
              <FormControl>
                <Input 
                  {...field} 
                  className="bg-white border-gray-200 focus:border-primary-400 focus:ring-primary-400/20 text-gray-900"
                  placeholder="Centro"
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="state"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="text-gray-700 font-medium">Estado</FormLabel>
              <FormControl>
                <Input 
                  {...field} 
                  className="bg-white border-gray-200 focus:border-primary-400 focus:ring-primary-400/20 text-gray-900"
                  placeholder="SP"
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="postal_code"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="text-gray-700 font-medium">CEP</FormLabel>
              <FormControl>
                <Input 
                  {...field} 
                  className="bg-white border-gray-200 focus:border-primary-400 focus:ring-primary-400/20 text-gray-900"
                  placeholder="12345-678"
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
    </div>
  );
};
